import axios from 'axios';

const CloudDataProvider = {
  uploadUsingPresignedUrl: async ({ presignedUrl, file, options = {} }) => {
    const { headers = {}, ...rest } = options;
    const config = {
      method: 'put',
      url: presignedUrl,
      data: file,
      ...rest,
      headers: {
        'Content-Type': file?.type || 'application/octet-stream',
        ...headers,
      },
    };
    await axios(config);
  },
};

export default CloudDataProvider;
